import React, { useEffect, useState } from 'react';
import slugify from 'react-slugify';

import Modal from 'components/common/modal/Modal';
import { Props, Results } from './EligibleCountries.interface';
import { countriesList, countriesList__container, countriesList__content } from './EligibleCountries.scss';

const EligibleCountries = ({ trigger }: Props): JSX.Element => {
  const [data, setData] = useState<Results>({ last_updated: '', countries: [] });
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('https://dev.1stformations.co.uk/items/eligible_countries') // Replace with your API endpoint
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        setData(jsonData.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className={countriesList}>
      <Modal trigger={trigger} lazy containerClass={countriesList__container} span>
        <div>
          <strong>Last updated: {data.last_updated}</strong>
          <div className={countriesList__content}>
            <h3>Check your country is eligible </h3>
            <p>
              We can register companies for customers from most countries in the world. Check if your country is
              eligible.
            </p>
            <ul>
              {data.countries.map((country) => (
                <li key={slugify(country)}>{country}</li>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EligibleCountries;
